<template lang="pug">
// 仅为了打包这样做
span(class="taskImage")
  img(v-if="flag === '1'", src="~assets/footprint/2025/task-1.png")
  img(v-if="flag === '2-l'", src="~assets/footprint/2025/task-2-l.png")
  img(v-if="flag === '3'", src="~assets/footprint/task-3.png")
  img(v-if="flag === '4-l'", src="~assets/footprint/task-4-l.png")
  img(v-if="flag === '5'", src="~assets/footprint/task-5.png")
  img(v-if="flag === '6'", src="~assets/footprint/task-6.png")
  img(v-if="flag === '7-l'", src="~assets/footprint/task-7-l.png")
  img(v-if="flag === '8'", src="~assets/footprint/task-8.png")
  img(v-if="flag === '9'", src="~assets/footprint/task-9.png")
  img(v-if="flag === '10-l'", src="~assets/footprint/2025/task-10-l.png")
  img(v-if="flag === '11-l'", src="~assets/footprint/2025/task-11-l.png")
  img(v-if="flag === '12'", src="~assets/footprint/2025/task-12.png")
  img(v-if="flag === '1-g'", src="~assets/footprint/2025/task-1-g.png")
  img(v-if="flag === '2-g'", src="~assets/footprint/2025/task-2-g.png")
  img(v-if="flag === '3-g'", src="~assets/footprint/task-3-g.png")
  img(v-if="flag === '4-g'", src="~assets/footprint/task-4-g.png")
  img(v-if="flag === '5-g'", src="~assets/footprint/task-5-g.png")
  img(v-if="flag === '6-g'", src="~assets/footprint/task-6-g.png")
  img(v-if="flag === '7-g'", src="~assets/footprint/task-7-g.png")
  img(v-if="flag === '8-g'", src="~assets/footprint/task-8-g.png")
  img(v-if="flag === '9-g'", src="~assets/footprint/task-9-g.png")
  img(v-if="flag === '10-g'", src="~assets/footprint/2025/task-10-g.png")
  img(v-if="flag === '11-g'", src="~assets/footprint/2025/task-11-g.png")
  img(v-if="flag === '12-g'", src="~assets/footprint/2025/task-12-g.png")
</template>
<script>
export default {
  name: 'TaskImage',
  props: {
    flag: String,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.taskImage img
  width: 100%
</style>
